import React,{ useContext, useEffect, useState, useMemo, useRef }  from 'react';
import './Welcome.css'
 export default function Welcome() {
    useEffect(() => {
        document.body.className = 'welcomPage';
        return () => { document.body.className = ''; }
    }, []);

  return (
    <>
    </>
  );
};


